import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './ListPage.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

export default function ArtistsList() {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE}/artists/public?limit=100`)
      .then((res) => setArtists(res.data.data || []))
      .catch(() => setArtists([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="list-page">
      <nav className="list-page__nav">
        <Link to="/" className="list-page__back">← Beranda</Link>
      </nav>

      <h1 className="list-page__title">Semua Artis</h1>

      {loading ? (
        <p className="list-page__empty">Memuat...</p>
      ) : artists.length === 0 ? (
        <p className="list-page__empty">Belum ada artis.</p>
      ) : (
        <div className="list-page__grid list-page__grid--artist">
          {artists.map((a) => (
            <Link to={`/artists/${a.slug}`} className="list-card list-card--artist" key={a.id}>
              <div className="list-card__photo list-card__photo--tall">
                {a.photo_url ? (
                  <img src={a.photo_url} alt={a.name} />
                ) : (
                  <div className="list-card__photo-fallback" />
                )}
              </div>
              <div className="list-card__body">
                {a.genre && <p className="list-card__date">{a.genre}</p>}
                <h3 className="list-card__title">{a.name}</h3>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
